import { uiComponents, uiStates } from '@/tools/viewState';

import { actionTypes, mutationTypes } from '@/types';

import { setURLToDataSource, getLangLanguageConent, getValueLanguageConent, generateUUID } from '@/tools/helpers';
import { SEARCH_SCOPES } from '@/tools/consts';
/**
 * This action open the ui--search with scope location,
 * it shows all locations given by ID and coresponding articles
 *
 * @param {*} store
 * @param {locationIDs} options
 */
export default function({ rootState, commit, dispatch }, { locationIDs, options, isExhibition }) {
	const data = locationIDs.reduce((acc, locationID) => {
		const location = rootState.dataSourceCFG.locationMap[locationID];
		if (!isExhibition) {
			acc.push({
				id: location._id,
				name: location._id,
				class: `separator--${location._id}`,
				isSeperator: true,
				iconName: 'separator',
				role: 'link',
				...location.languageContent.reduce(
					(acc, lc) => {
						if (lc.title) acc.title[lc.languageISO] = lc.title;
						if (lc.description) acc.description[lc.languageISO] = lc.description;
						if (lc.coverImage)
							acc.cover[lc.languageISO] = lc.coverImage
								? setURLToDataSource(`../media-${lc.coverImage}/512`, rootState.dataSourceURL)
								: undefined;
						return acc;
					},
					{ title: {}, description: {}, cover: {} }
				),
			});
		}

		location.tours.forEach(tour => {
			const languageContent = getLangLanguageConent(tour.languageContent, rootState);
			const { source } = tour.coverID.languageContent.filter(
				lc => lc.languageISO === rootState.persistent.language
			)[0];
			languageContent.cover = setURLToDataSource(`../media-${source}/512`, rootState.dataSourceURL);
			acc.push({
				name: tour.name,
				class: 'data--' + tour.name,
				active: `${rootState.tour.tourCurrentID === tour._id}`,
				url: '',
				click: () => {
					dispatch(actionTypes.tourStart, { tourID: tour._id });
					commit(mutationTypes.viewStateSetUiState, {
						id: uiComponents.uiSearchLocations,
						uiState: uiStates.hidden,
					});
					commit(mutationTypes.viewStateSetUiState, {
						id: uiComponents.uiMap,
						uiState: uiStates.hidden,
					});
				},
				...languageContent,
				title: getValueLanguageConent(tour.languageContent, 'title', rootState),
				description: getValueLanguageConent(tour.languageContent, 'description', rootState),
			});
		});

		location.articles.forEach(({ article, exhibitionID }) => {
			const languageContent = getLangLanguageConent(article.languageContent, rootState);
			languageContent.cover = languageContent.coverImage
				? setURLToDataSource(`../media-${languageContent.coverImage}/512`, rootState.dataSourceURL)
				: undefined;

			acc.push({
				key: generateUUID(),
				name: article.name,
				class: 'data--' + article.name,
				active: `${rootState.articleContent.hasOwnProperty(article.id)}`,
				url: '',
				click: () => {
					if (rootState.tour.tourCurrentID) {
						dispatch(actionTypes.pushUrl, {
							url: `/${exhibitionID}/tour/${rootState.tour.tourCurrentID}/${article.id}`,
							replace: false,
						});
					} else {
						dispatch(actionTypes.setExhibition, { exhibitionID, articleID: article.id });
					}
					commit(mutationTypes.viewStateSetUiState, {
						id: uiComponents.uiSearchLocations,
						uiState: uiStates.hidden,
					});
					commit(mutationTypes.viewStateSetUiState, {
						id: uiComponents.uiMap,
						uiState: uiStates.hidden,
					});
				},
				...languageContent,
				title: getValueLanguageConent(article.languageContent, 'title', rootState),
				description: getValueLanguageConent(article.languageContent, 'description', rootState),
			});
		});
		return acc;
	}, []);
	// const alterationFunctions = [
	// 	function(array) {
	// 		return state.query ? array.filter(entry => !entry.isSeperator) : array; // remove seperators on query results
	// 	},
	// ];
	commit(mutationTypes.searchSetData, {
		scope: SEARCH_SCOPES.locations,
		data,
		searchOptions: {
			keys: ['title', 'description'],
			threshold: 0.3,
			caseSensitive: false,
		},
		options: Object.assign({}, options, { closeButton: !isExhibition }),
	});
	commit(mutationTypes.viewStateSetUiState, {
		id: uiComponents.uiSearchLocations,
		uiState: uiStates.maximised,
	});
}
